import * as fromDatatype from '../datatype-library';

export interface bl_wf_issue_dashboard_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  dashboard_name: fromDatatype.VarcharDatatypeInterface;
  dashboard_code: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_wf_issue_dashboard_RowClass implements bl_wf_issue_dashboard_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  dashboard_name: fromDatatype.VarcharDatatypeInterface;
  dashboard_code: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
